module.exports = {
	"pagination": {
		"DescribeInstanceInformation": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults",
			"result_key": "InstanceInformationList"
		},
		"ListAssociations": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults",
			"result_key": "Associations"
		},
		"ListCommandInvocations": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults",
			"result_key": "CommandInvocations"
		},
		"ListCommands": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults",
			"result_key": "Commands"
		},
		"ListDocuments": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults",
			"result_key": "DocumentIdentifiers"
		},
		"DescribeActivations": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults",
			"result_key": "ActivationList"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/apis/ssm-2014-11-06.paginators.json
 ** module id = 1004
 ** module chunks = 0
 **/